<template>
  <div class="summary vh-100 pl-3 pr-3 d-flex justify-content-center align-items-center">
    <div class="row">
      <div class="col-md-3"></div>
      <div class="col-md-6 text-center">
        <div class="mb-5 mr-2 ml-2">
          <img
              src="../../assets/img/screenshots/summary1.png"
              class="img-thumbnail img-shadow screenshot"
              data-aos="fade-up"
              data-aos-duration="1000"
              data-aos-once="false"
          />
        </div>
        <h1 class="title text-white">
          Maak uw financiën gemakkelijk
        </h1>
        <div class="sub-title text-white">
          SimpleFinance helpt ondernemers de financiën makkelijk en zorgvuldig bij te houden. Verstuur facturen,
          beheer klanten, houd kosten bij. Allemaal op één plek. Zo houd jij, als ondernemer,
          meer tijd over voor andere zaken.
        </div>
      </div>
      <div class="col-md-3"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Summary'
};
</script>

<style scoped>
.summary {
  padding-bottom: 150px;
  min-height: 950px;
  background: #008fff;
  background: linear-gradient(112deg, #008fff, #db42f5);
  background-size: 120% 120%;
  animation: animatedbg 12s ease infinite;
  -webkit-clip-path: polygon(0 0, 100% 0, 100% 100%, 0 90%);
  clip-path: polygon(0 0, 100% 0, 100% 100%, 0 90%);
}
</style>
